// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_p4-0";
export var discountCodeInput = "_p4-1";